import { render } from "./TextGridItem.vue?vue&type=template&id=6abbecf2"
import script from "./TextGridItem.vue?vue&type=script&lang=js"
export * from "./TextGridItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__